import * as React from "react";
import { AppLayout } from "../../layouts/app";
import { CrudLayout } from "../../layouts/crud";
import { DataGridWithActions } from "../../components/dataGridWithActions";
import {
    useContext,
    useEffect,
    useState
} from "react";
import { SnackBar } from "../../components/snackBar";
import { DriversService } from "../../services/drivers";
import { NotificationManager } from "react-notifications";
import { BreadcrumbContext } from "../../contexts/breadcrumb";
import { Link } from "react-router-dom";
import { Typography, Button, IconButton, Grid, FormGroup, FormControlLabel, Switch } from "@mui/material";
import moment from "moment";
import { DriverForm } from "./form";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const columns = [
    {
        field: 'name',
        headerName: 'Nome do motorista',
        flex: 2,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'cpf',
        headerName: 'CPF',
        flex: 1.5,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'cnhNumber',
        headerName: 'CNH',
        flex: 1.5,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'cnhExpirationDate',
        headerName: 'Data Expiração CNH',
        type: 'date',
        flex: 1.5,
        editable: false,
        valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'rfidTagValue',
        headerName: 'Tag RFID',
        flex: 2,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'companyName',
        headerName: 'Empresa',
        flex: 2,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
];

export const Drivers = () => {
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [drivers, setDrivers] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const driversService = new DriversService();
    const [openSnackBar, setSnackBar] = useState(false);
    const [idDriver, setDriverId] = useState();
    const [itemToEdit, setItemToEdit] = useState();

    useEffect(() => {
        const breadcrumbs = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="2" color="text.primary">
                Motoristas
            </Typography>,
        ];

        setBreadcrumbs(breadcrumbs);
        getDriversData();
    }, []);

    const getDriversData = () => {
        driversService.getDrivers().then(res => {
            var reportData = res.data;
            reportData = reportData.filter(element => element.rfidTagValue !== "00000000000000");
            setDrivers(reportData);
            setLoadingData(false);
            setItemToEdit();
        }).catch(error => {
            console.error(error);
            setLoadingData(false);
            setItemToEdit();
        });
    }

    const handleUpdate = (updatedDriver) => {
        const rfidTag = updatedDriver.rfidTagValue;
        if (!/[a-zA-Z]/.test(rfidTag.toString())) {
            driversService.updateDriver(updatedDriver).then(res => {
                if (res.status == 200) {
                    NotificationManager.success('Registro atualizado com sucesso.', "", 3000);
                    getDriversData();
                }

            }).catch(error => {
                NotificationManager.error('Erro ao atualizar registro.', "", 3000);
                console.error(error);
            });

        } else {
            NotificationManager.warning('O campo RFID deve contaer apenas números!', "", 3000);
        }

    }

    const handleDelete = (id) => {
        driversService.deleteDriver(id).then(res => {
            if (res.status == 200) {
                NotificationManager.success('Registro removido.', "", 3000);
                getDriversData();
                setDriverId(id);
                setSnackBar(true);
            }

        }).catch(error => {
            NotificationManager.error('Erro ao remover registro.', "", 3000);
            console.error(error);
        });
    }

    const handleCloseSnackBar = () => {
        setSnackBar(false);
    }

    const handleUndoOperation = () => {
        driversService.undoDriver(idDriver).then((res) => {
            getDriversData();
            setSnackBar(false);
        }).catch((error) => {
            console.error(error);
        });

    }

    const handleOpenModal = (item) => {
        setItemToEdit(item);
    };

     const handleSetItemToEdit = () => {
        setItemToEdit();
    }

    const action = (
        <React.Fragment>
            <Button color="success" size="small" onClick={handleUndoOperation}  >
                DESFAZER
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSnackBar}
            >
                <CloseRoundedIcon fontSize="small" sx={{ color: 'black' }} />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
            <AppLayout>
                <Grid item xl={2} md={3} sm={4} xs={6}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch
                                sx={{
                                    height: "45px",
                                    width: "70px",
                                    "& .MuiSwitch-switchBase": {
                                        margin: 0,
                                        padding: 1,
                                        transform: "translateX(2px)",
                                        "&.Mui-checked": {
                                            color: "#fff",
                                            transform: "translateX(30px)",
                                            "& .MuiSwitch-thumb:before": {},
                                            "& + .MuiSwitch-track": {
                                                opacity: 1,
                                                backgroundColor: "#5c7fb8",
                                            },
                                        },
                                    },
                                    "& .MuiSwitch-thumb": {
                                        backgroundColor: "#21519f",
                                        width: 28,
                                        height: 28,
                                        "&:before": {
                                            content: "''",
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            left: 1,
                                            top: 0,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                        },
                                    },
                                    "& .MuiSwitch-track": {
                                        opacity: 1,
                                        backgroundColor: "#5c7fb8",
                                        borderRadius: 20 / 2,
                                    },
                                }}
                                defaultChecked
                                disabled={true}
                            />}
                            sx={{ width: '80px' }}
                            label="Veículos"

                        />

                    </FormGroup>
                </Grid>
                <CrudLayout
                    title="Motoristas"
                    formTitle='Cadastro de Motorista'
                    form={<DriverForm />}
                    hasNewButton
                    itemToEdit={itemToEdit}
                    cleanItemToEdit={handleSetItemToEdit}
                    onModalClosed={getDriversData}
                    children={
                        <DataGridWithActions
                            columns={columns}
                            editMode="row"
                            data={drivers}
                            loadingData={loadingData}
                            updateRecord={handleUpdate}
                            deleteRecord={handleDelete}
                            handleOpenModal={handleOpenModal}
                            onEditOpenModal={true}
                            rowsPerPageOptions={[10]}
                            pageSize={10}
                        />
                    }
                />
            </AppLayout>

            <SnackBar open={openSnackBar} side={"left"} action={action} />

        </>
    );
}